var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"recruit-content"},[((_vm.getUrlParam('type') === 'share') && _vm.showWantDo)?_c('img',{staticClass:"recruit-icon",attrs:{"src":_vm.iWantDoIcon,"alt":"我也要招生"},on:{"click":_vm.handleClickRecruit}}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }